import { InvoicesTab } from "./InvoicesTab";

export function BillingPage() {
  return (
    <div className="w-full">
      <div className="mb-8">
        <h1 className="text-2xl font-semibold mb-2">Invoices</h1>
        <p className="text-muted-foreground">
          View and manage your invoices
        </p>
      </div>

      <InvoicesTab />
    </div>
  );
}
